import React from 'react';
import { RotationMsgWrapper, RotationMsgLeftWrapper, ExclamationTriangleIcon } from './RotationSyncMsg.styles';
import useRotation from '../../../app/useRotation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RotationSyncMsgComponent: React.FC = () => {
    const { rotationAndImosSyncNotUpToDateMsg, rotationAndImosSyncNotUpToDateTooltip } = useRotation();

    const warningButton = () => {
        return (
            <ExclamationTriangleIcon>
                <FontAwesomeIcon icon="exclamation-triangle" />
            </ExclamationTriangleIcon>
        );
    };

    const getAndShowMsg = () => {
        const msg = rotationAndImosSyncNotUpToDateMsg();
        const tooltip = rotationAndImosSyncNotUpToDateTooltip();
        if (msg) {
            return (
                <RotationMsgWrapper title={tooltip}>
                    <RotationMsgLeftWrapper>{warningButton()}</RotationMsgLeftWrapper>
                </RotationMsgWrapper>
            );
        }
        return '';
    };

    return <>{getAndShowMsg()}</>;
};

export default RotationSyncMsgComponent;
